let backendHost;
let webHost;
let env;
const apiVersion = "v1";

const hostname = window && window.location && window.location.hostname;

if (hostname === "member.getduos.com") {
  webHost = "https://member.getduos.com";
  backendHost = "https://api.getduos.com";
  env = "prod";
} else if (hostname === "member.getduos.xyz") {
  webHost = "https://member.getduos.xyz";
  backendHost = "https://api.getduos.xyz";
  env = "dev";
} else {
  webHost = "http://localhost:3000";
  backendHost = "http://localhost:9000";
  env = "local";
}

export const WEB_ROOT = `${webHost}`;
export const API_ROOT = `${backendHost}/${apiVersion}/rest/member`;
export const MEMBER_BASEURL = backendHost;
export const ENV = `${env}`;
